import { render, staticRenderFns } from "./DesgloseTiposComponent.vue?vue&type=template&id=4665889f"
import script from "./DesgloseTiposComponent.vue?vue&type=script&lang=js"
export * from "./DesgloseTiposComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports